import type {ILabel} from '../../../../types'

export default {
    loading: <ILabel>{
        de: 'Lädt...',
        en: 'Loading...',
        es: 'Cargando...',
        fr: 'Chargement...',
        nl: 'Lading...',
        it: 'Caricamento...',
    },
    errorText: <ILabel>{
        de: 'Gerade sind keine Daten verfügbar.',
        en: 'No data available at the moment.',
        es: 'No hay datos disponibles por el momento.',
        fr: 'Aucune donnée n\'est disponible pour le moment.',
        nl: 'Momenteel geen gegevens beschikbaar.',
        it: 'Nessun dato disponibile al momento.',
    }
}